import { render, staticRenderFns } from "./RichEditor.vue?vue&type=template&id=d980b422"
import script from "./RichEditor.vue?vue&type=script&lang=js"
export * from "./RichEditor.vue?vue&type=script&lang=js"
import style0 from "./RichEditor.vue?vue&type=style&index=0&id=d980b422&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports